<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button
    id="pendo-eap-submission"
    data-test="eap-save-button"
    [type]="IrisButtonTypes.PRIMARY"
    [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
    [disabled]="submitting || !allowNext"
    (click)="newClientSubmit()"
  >
    <ng-container *ngIf="!submitting; else spinner">
      Next
    </ng-container>
    <ng-template #spinner>
      <mat-spinner diameter="24"></mat-spinner>
    </ng-template>
  </iris-button>
</ng-template>

@if (fromDirectBooking) {
  <div class="preamble">
    <h1 class="heading">You're nearly there</h1>
    <p class="edit-profile-insurance-message">
      In order to use your EAP to help pay for therapy, we need some more details. You’ll need your authorization number handy to complete this form.
    </p>
  </div>
}

<div [class.from-direct-booking]="fromDirectBooking">
  <ng-container *ngIf="!isProposeATime; else proposeATimeEAPQuestion">
    <div class="eap-wrapper sondermind-design-system buffer-bottom">
      <h3 class="section-label" data-test="eap-section-header-text">Employee Assistance Program</h3>
      <p data-test="add-eap-question-text">
        You indicated you would like to use EAP to help pay for therapy.
        <br>
        <br>
        Would you like to add your EAP information? You’ll need your authorization number handy.
      </p>
      <iris-radio-group
        id="pendo-eap-checkbox"
        [options]="yesOrNo"
        [formControl]="addingEapControl"
        data-test="eap-checkbox">
      </iris-radio-group>
    </div>
  </ng-container>
  
  <ng-template #proposeATimeEAPQuestion>
    <div class="eap-wrapper buffer-bottom">
      <h2 class="iris-h2-responsive section-label" data-test="insurance-section-header-text">Want to add your EAP details now?</h2>
      <p data-test="add-insurance-card-question-text">
        In order to use your EAP to help pay for therapy, we need some more details. You’ll need your authorization number handy to complete this form.
      </p>
      <iris-radio-group
        id="pendo-eap-checkbox"
        [options]="yesOrNo"
        [formControl]="addingEapControl"
        data-test="eap-checkbox"
      >
      </iris-radio-group>
    </div>
  </ng-template>
  
  <client-eap-add
    #eapForm
    [useInline]="true"
    [useInSessionRequest]="useInSessionRequest"
    [ngClass]="{'hide-visually': !addingEapControl.value}"
  ></client-eap-add>
  
  @if (!fromDirectBooking) {
    <div class="eap-wrapper buffer-top">
      <iris-button-container [alignment]="IrisButtonContainerAlignments.END">
        <ng-container *ngTemplateOutlet="actionButton"></ng-container>
      </iris-button-container>
    </div>
  }
</div>
